<template>
  <div class="row">
    <div class="col-12">
      <div class=" align-items-center mb-2">
        <div class="row">
          <div class="col-9">
            <h4 class="mb-0 ml-75">
              <feather type="layers" class="font-medium-3 mr-1">
              </feather>
              Case Type
            </h4>
          </div>
          <div class="col-3">
            <div class="d-flex align-items-center justify-content-end">
              <button type="button"
                      @click="showCreateCaseTypeModel = true"
                      class="btn btn-primary btn-sm">
                <span class="text-nowrap">Create</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CommonTableStore
        :url="url"
        :tableHeaderValues="tableHeaderValues"
        :actions="actions"
        :deleteActions="deleteActions"
        :mutedData="mutedData"
        :storageKey="storageKey"
        :externalTotalRecord="externalTotalRecord"
        :show-per-page="true"
        class="w-100"
    />
    <CaseTypeCreateModal :forUpdate="false" @completed="completedAction" :show="showCreateCaseTypeModel" @hide="showCreateCaseTypeModel = false" />
    <CaseTypeCreateModal :forUpdate="true" :data="data" @completed="showUpdateCaseTypeModel = false" :show="showUpdateCaseTypeModel" @hide="showUpdateCaseTypeModel = false" />

  </div>
</template>
<script>
import CaseTypeCreateModal from "../../CaseTypeCreateModal.vue";
export default {
  components: {
    CaseTypeCreateModal,
  },
  props: [],
  mounted() {
    localStorage.setItem("url", this.url);
    this.checkDataInStore(this.url)
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      data:{},
      force:false,
      updateData:[],
      url: "v1/cms-get-casetype",
      storageKey: "caseTypeTab",
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name"
        },
      ],
      actions: [
        {
          title: "update",
          cta: (row, index) => {
            this.data = {
              ...row,
              name : row.name,
              id:row._id,
              status: row.status,
              idx: index,
              storageKey: this.storageKey
            }
            this.showUpdateCaseTypeModel = true
          }
        }
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            this.deleteRecord(row);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: "",
      showCreateCaseTypeModel:false,
      showUpdateCaseTypeModel:false,
    };
  },
  methods: {
    completedAction(){
      this.$store.dispatch('renderPagination', !this.force);
      this.force = !this.force;
      this.showCreateCaseTypeModel = false
      this.showUpdateCaseTypeModel = false
    },
    deleteRecord(row) {
      this.makeRequest("post", "v1/cms-update-casetype", {
        status: row.status == true ? 1 : 0,
        id: row._id,
        name: row.name
      });
    }
  },
}
</script>